<template>
  <div
    class="table-cell title d-flex justify-content-between text-nowrap"
    :class="`level-${level}`"
    :title="isSegment ? title : null"
    :data-bs-toggle="isSegment ? 'tooltip' : null"
    :data-bs-placement="isSegment ? 'top' : null"
  >
    <div>
      <button
        v-if="shouldShowExpandGroup"
        class="btn btn-link"
        @click="onExpandGroup({ group })"
      >
        <span class="table-cell-inner fs-6">
          <i
            class="bi bi-chevron-right fs-5 px-0 table-cell-title-arrow"
            :class="isExpandedGroup && 'rotated'"
          ></i>
          {{ title }}
        </span>
      </button>
      <div v-else>
        <span class="table-cell-inner fs-6">
          {{ title }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PulsTableTitleCell',
  props: {
    group: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    onExpandGroup: {
      type: Function,
      default: null
    },
    level: {
      type: Number,
      default: 0
    },
    isExpandedGroup: {
      type: Boolean,
      default: false
    },
    isSegment: {
      type: Boolean,
      default: false
    },
    addRowGroup: {
      type: String,
      default: ''
    }
  },
  computed: {
    shouldShowExpandGroup() {
      const childrenLength = this.addRowGroup === this.group.name ? 1 : 0
      return (
        this.group.children &&
        this.group.children.length > childrenLength &&
        this.onExpandGroup
      )
    },
    title() {
      return this.group.messages
        ? this.$tr(this.group.messages, 'title')
        : this.group.title
    }
  }
}
</script>

<style lang="scss">
.table-cell-title-arrow {
  transition: transform 0.2s ease;
  &.rotated {
    transform: rotate(90deg);
  }
}
.table-cell-inner {
  text-overflow: ellipsis;
}
.table-cell.title > div {
  min-width: 0;
  > button,
  > div {
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
